const modelListFactory = (factory, params) => (list) => list.map((item) => factory(item, params));

export default modelListFactory;
